import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { FileSelectorViewModel, ServerSideDataLoader } from "uicomponents";
import { CarModelManipulationViewModel, carModel } from "./carModelManipulation-viewModel";

export class CarModelManipulationView extends View<CarModelManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-25CCBEF8-58CE-4A1C-9CE9-E27560EB794B"
    }
    loadHtml(): string {
        let element = require('./carModelManipulation.html').default;
        let style = require('./carModelManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set carModels(v: ObservableArray<carModel>) { this._carModels = v; } public get carModels(): ObservableArray<carModel> { return this._carModels;} private _carModels: ObservableArray<carModel>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    
    import() {
        this.dataContext.import();
    }
    
    export() {
        this.dataContext.export();
    }

    requestCarModelCreation(){
        this.dataContext.requestCarModelCreation();
    }
}
